import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import styles from '../domainManager/style.scss';
import PortalTextBox from '../../portal/portalTextBox';
import TextfieldFloatingText from '../../portal/textfieldFloatingText';

@inject('translationsStore', 'windowsDomainsStore') @observer
export default class DnsDomainNameCell extends Component {

    handleDnsBlured = _ => this.props.windowsDomainsStore.validateDnsDomain();

    handleDnsChanged = e => this.props.windowsDomainsStore.setDnsDomain(e.target.value);

    render() {

        const { fullyQualifiedName } = this.props.windowsDomainsStore.getDomainById(this.props.id);
        const { chosenId, chosenFullyQualifiedName, editDomainProgress } = this.props.windowsDomainsStore;
        const tooltip = this.props.translationsStore.translate('DNS_DOMAIN_TOOLTIP');

        return (
            chosenId === this.props.id ?
                <div
                    className={classNames(styles.domainTableColumnEdit)}
                    title={fullyQualifiedName}
                >
                    <PortalTextBox
                        dataCy={'dns-domain-field'}
                        disabled={editDomainProgress}
                        hintText={this.props.translationsStore.translate('DNS_DOMAIN')}
                        onBlur={this.handleDnsBlured}
                        onChange={this.handleDnsChanged}
                        value={chosenFullyQualifiedName}
                        errorText={this.props.windowsDomainsStore.domainDnsValidationMessage}
                        helpTooltipText={
                            <div>
                                {tooltip.split('.').map(text => <div key={text}>{text}.</div>)}
                            </div>
                        }
                        floatingLabelText={
                            <TextfieldFloatingText
                                title={this.props.translationsStore.translate('DNS_DOMAIN')}
                                required={true} />
                        }
                    />
                </div> :
                <div
                    className={classNames(styles.domainTableColumnDisplay)}
                    title={fullyQualifiedName}
                >
                    {fullyQualifiedName}
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/generalSettings/domainManagerGridFormatter/dnsDomainCell.jsx